import { defineMessages } from 'react-intl';

export default defineMessages({
  continueToPurpleFinancing: {
    id: 'ChargeAfterButton.continueToPurpleFinancing',
    description: 'Continue To Purple Financing button title',
    defaultMessage: 'Continue to Purple Financing',
  },
  payWithPurpleCreditCard: {
    id: 'ChargeAfterButton.payWithPurpleCreditCard',
    description: 'Pay With Purple Credit Card button title',
    defaultMessage: 'Pay with Purple Credit Card',
  },
});
